<div class="container">
  <div class="emote-list">
    @for(emoji of chatService.emotes; track emoji.key){
    <div class="emote">
      <img [src]="emoji.image" (click)="onEmoteClick(emoji.key)" />
    </div>
    }
  </div>
</div>
